export const JWEB_THRESHOLD_TIME = 30;
export const JWEB_MAX_THRESHOLD_TIME = 35;
